import { render, staticRenderFns } from "./SelectionItems.vue?vue&type=template&id=209d0e8d&"
import script from "./SelectionItems.vue?vue&type=script&lang=js&"
export * from "./SelectionItems.vue?vue&type=script&lang=js&"
import style0 from "./SelectionItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports